
import React from 'react'
import { Row, Col } from 'antd'
import { Icon } from '@ant-design/compatible'
import './SelectedShow.less'

const SelectedShow: React.FC<ISelectedShowProps> = (props) => {

  const onClose = (v: any) => {
    props.deleteSelect && props.deleteSelect(v)
  }

  return (
    <ul className="selected-show">
      {props.selectedRows && props.selectedRows.map((v: any) => {
        return (
          < li className="tag" key={v.jobNumber}><Row><Col span={20}>{v.name ? v.name : '--'}</Col><Col span={1} offset={1}><Icon type="close" onClick={() => onClose(v)} /></Col></Row></li>
        )
      })}
    </ul>
  )
}

interface ISelectedShowProps {
  deleteSelect?: any
  selectedRows?: any
}

export default SelectedShow
